import { defineLevel } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MONDE 2 · NIVEAU 1 — LE TISSAGE.

     0:00  intro          6 s
     0:06  bloc D1       26 s   le tissage — un couloir qui se déplace
     0:32  respiration    4 s
     0:36  bloc D2       30 s   l'ancrage — une région qu'on perd
     1:06  respiration    4 s

   Premier niveau du monde 2 (Le Champ), sans boss. Le monde apprend à SE
   DÉPLACER : les places sûres y sont mobiles. D1 puis D2 posent les deux
   premières formes, le niveau se referme sur une accalmie.

   ⚠️ Blocs 0 → 4 de l'ancien `monde-2`, re-basés (offset 0). Espacement
   relatif intact.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineLevel({
  id: 'monde-2-1',
  duration: 70,
  blocks: [
    { at: 0, wave: 'intro' },
    // Premier CHAMP d'astéroïdes du jeu — le monde s'appelle « Le Champ », c'est
    // sa signature. Clairsemé et DÉCALÉ hors de la colonne centrale : le champ
    // enseigne à louvoyer sans jamais fermer la ligne de tir, et le Colosse posé
    // franchement à droite pose la première décision « je le contourne ».
    {
      at: 6,
      wave: 'd1-tissage',
      obstacles: [
        { at: 2, obstacle: 'astero-eclat', x: -210 },
        { at: 5, obstacle: 'astero-eclat', x: 200 },
        { at: 9, obstacle: 'astero-bloc', x: -260 },
        { at: 14, obstacle: 'astero-eclat', x: 170 },
        { at: 18, obstacle: 'astero-colosse', x: 255 },
      ],
    },
    { at: 32, wave: 'respiration' },
    { at: 36, wave: 'd2-ancrage' },
    { at: 66, wave: 'respiration' },
  ],
});
